function hulkValidation() {
    var hulk_flag_custom = 0;
    $("body").on('click', '.hulkapps_submit_cart', async function (e) {
        if (hulk_flag_custom == 0) {
            e.preventDefault();
            e.stopPropagation();
            const validateObjectData = await validate_options(window.hulkapps.product_id);
            if (validateObjectData) {
                hulk_flag_custom = 1;
                $('.hulkapps_submit_cart').click();
            }
        }
    });

}

window.addEventListener('load', () => {
  $ = hulkapps_jQuery;
  hulkValidation();
})